import { ReactErrorBoundary } from '@Components/errorHandling';
import { SENTRY_OPTIONS } from '@Constants/sentryConstants';
import { FeatureFlagsProvider } from '@Contexts/featureFlags';
import { CustomDomainContext } from '@Contexts/customDomain/CustomDomainContext';
import { useCustomDomainState } from '@Contexts/customDomain/useCustomDomainState';
import { BootSpinner } from '@Components/BootSpinner/BootSpinner';
import { useSentry } from '@synqo/cloud-client-shared';
import { useMsal } from './msal/useMsal';
import { useMsalConfiguration } from './msal/useMsalConfiguration';
import { SynqoCloudRouter } from './Routing/setupRouting';

export function Root() {
    useSentry(SENTRY_OPTIONS);

    const customDomain = useCustomDomainState();
    const pca = useMsal(useMsalConfiguration(customDomain));

    if (pca === undefined) {
        return <BootSpinner />;
    }

    return (
        <ReactErrorBoundary>
            <CustomDomainContext.Provider value={customDomain}>
                <FeatureFlagsProvider>
                    <SynqoCloudRouter pca={pca} />
                </FeatureFlagsProvider>
            </CustomDomainContext.Provider>
        </ReactErrorBoundary>
    );
}
